<div class="dcl-layout">
    <section id="stories-container">
        <ng-container *ngFor="let story of stories; let i=index;" [ngSwitch]="story.generalPurposeStrings.template">
            <pixie-revenue
                *ngSwitchCase="'5-revenue-hero'"
                [id]="story.generalPurposeStrings.storyName" 
                [site-id]="siteId"
                [desktop-mobile]="desktopOrMobile"
                [data]="story"
                [story-order]="storyOrder"
                class="story template-{{story.generalPurposeStrings.template}} container-fluid" >
            </pixie-revenue>
            <pixie-destination
                *ngSwitchCase="'4-destination-hero'"
                [id]="story.generalPurposeStrings.storyName" 
                [site-id]="siteId"
                [desktop-mobile]="desktopOrMobile"
                [data]="story"
                [story-order]="storyOrder"
                class="story template-{{story.generalPurposeStrings.template}} container-fluid" >
            </pixie-destination>
            <pixie-crosspromo
                *ngSwitchCase="'cross-promo'"
                [id]="story.generalPurposeStrings.storyName" 
                [site-id]="siteId"
                [desktop-mobile]="desktopOrMobile"
                [data]="story"
                [story-order]="storyOrder"
                class="story template-{{story.generalPurposeStrings.template}} container-fluid" >
            </pixie-crosspromo>
            <pixie-vpg
                *ngSwitchCase="'dcl-banner'"
                [id]="story.generalPurposeStrings.storyName"
                [site-id]="siteId"
                [desktop-mobile]="desktopOrMobile"
                [data]="story"
                [story-order]="storyOrder"
                class="story template-{{story.generalPurposeStrings.template}} container-fluid">
            </pixie-vpg>
            <pixie-awards
                *ngSwitchCase="'awards'"
                [id]="story.generalPurposeStrings.storyName"
                [site-id]="siteId"
                [desktop-mobile]="desktopOrMobile"
                [data]="story"
                [story-order]="storyOrder"
                class="story template-{{story.generalPurposeStrings.template}} container-fluid">
            </pixie-awards>
            <pixie-dvic-banner
                *ngSwitchCase="'dvic-offer'"
                [id]="story.generalPurposeStrings.storyName"
                [site-id]="siteId"
                [desktop-mobile]="desktopOrMobile"
                [data]="story"
                [story-order]="storyOrder"
                class="story template-{{story.generalPurposeStrings.template}} container-fluid">
            </pixie-dvic-banner>
        </ng-container>
    </section>
</div>